import { useEffect, useMemo, useState } from "react";
import { useResponsive } from "../../../../hooks";
import { standardMeasurementData, Measurement } from "./types";
import { DesktopView } from "./desktop";
import { MobileView } from "./mobile";

export function RoofMeasurementTable(props: {
    measurements: any;
    setMeasurements?: any;
    excludeMeasurementTypes?: string[];
}) {
    const { measurements, setMeasurements, excludeMeasurementTypes = [] } = props;
    const measurementRows = useMemo(() => {
        if (excludeMeasurementTypes.length === 0) return standardMeasurementData;
        const excluded = new Set(excludeMeasurementTypes);
        return standardMeasurementData.filter((item) => !excluded.has(item.name));
    }, [excludeMeasurementTypes]);
    const [data, setData] = useState(measurementRows);
    const { isMobile } = useResponsive();

    const processedData = () => {
        if (!measurements || measurements.length === 0) {
            setData(measurementRows);
            return;
        }
        const newData = measurementRows.map((item: any) => {
            const entry = measurements.find((entry: any) => entry.MeasurementType === item.name);
            if (!entry) {
                return item;
            }
            return {
                ...item,
                name: entry.MeasurementType,
                total: entry.CalculatedValue,
                actual: entry.ActualValue,
                id: entry.Id,
            };
        });

        setData(newData);
    };

    const handleEdit = (event: { id: string; actual: number }) => {
        const { id, actual } = event;
        setMeasurements((prev: Measurement[]) => prev.map((m) => (m.Id === id ? { ...m, ActualValue: actual } : m)));
    };

    useEffect(() => {
        processedData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [measurements, measurementRows]);

    if (isMobile) {
        return <MobileView data={data} handleEdit={handleEdit} />;
    }

    return <DesktopView data={data} handleEdit={handleEdit} />;
}
